
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/WorkflowStep/WorkflowStep.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./WorkflowStep.html');
        
        var script = require('./WorkflowStep.ts').default;
        module.exports = require('./WorkflowStep.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    